// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_eU","advertDetailContactItem__link":"c-n_eV"};